module.exports = __webpack_public_path__ + "static/after2-f8f703fea6a97514878d9835c8a42572.jpg";